import { createModuleStateSelector, getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import { createSelector } from 'reselect';
import { MR_MODULE_NAME } from '../constants/modules';

export default createSelector(
  getIsLoggedInSelector,
  createModuleStateSelector(MR_MODULE_NAME),
  (isLoggedIn, multipleRewardsModuleState) => {
    if (!isLoggedIn) {
      return false;
    }

    if (!multipleRewardsModuleState) {
      return true;
    }

    // selectedKey is the string "undefined" when the user has not selected a card
    return multipleRewardsModuleState.toJS()?.selectedKey === 'undefined';
  }
);
